<!-- bbs > 메인 -->
<template>
  <div class="content-wrap am-page-wrap" :class="amPage">
    <div class="navi-area">
      <div class="m-navi-top">
        <c-btn01 :btnText="t('message.goToHome')" @click="utils.movePage('/actionManagement')"/>
      </div>
      <NaviBox @closeMobileMenu="amListOpen"/>
    </div>
    <div class="page3">
      <div class="tab-group ty02">
        <v-tabs
          v-model="tab"
        >
          <v-tab value="tabCont1">{{t('message.monitoring')}}</v-tab>
          <v-tab value="tabCont2">{{t('message.report')}}</v-tab>
          <v-tab value="tabCont3">{{t('message.activityHistory')}}</v-tab>
        </v-tabs>
        <c-btnText01 :btnText="t('message.generateQRCode')" class="ty04" @click="onClickQR" v-if="tab=='tabCont1'"/>
      </div>
      <div class="content-box bg-none tab-cont-wrap">
        <div class="tit-group02 mo-ty01">
          <div class="navi-btn">
            <v-btn @click="amListOpen"/>
          </div>
        </div>
        <v-tabs-window v-model="tab">
          <v-tabs-window-item value="tabCont1">
            <monitoringTabCont1 :is-active="tab === 'tabCont1'"/>
          </v-tabs-window-item>
          <v-tabs-window-item value="tabCont2">
            <monitoringTabCont2 :is-active="tab === 'tabCont2'"/>
          </v-tabs-window-item>
          <v-tabs-window-item value="tabCont3">
            <monitoringTabCont3 :is-active="tab === 'tabCont3'"/>
          </v-tabs-window-item>
        </v-tabs-window>
      </div>
    </div>
  </div>
  <!--popup: qrcord 생성-->
  <DialogQrcord v-model="DialogQRModel"
                :pop-title="t('message.QRCode')"
                @close="DialogQRModel=false"/>
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useCommonStore } from "@/store/common";
import BbsService from "@/services/bbs.service";
import utils from "@/common/Utils";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)
const route:any = useRoute()

//bind
const tab = ref('')
const DialogQRModel = ref(false)
const amPage = ref('naviOff')
const tabIdx = route.params.tab?route.params.tab:''
const viewIdx = route.params.idx?route.params.idx:storeRef.viewIdx.value
const snackbar = ref(false)
const snackText = ref('')


//hook
onMounted(() => {
  tab.value = 'tabCont'+tabIdx
})

// function
function amListOpen(){
  if(amPage.value == 'naviOff')
    amPage.value = 'naviOn'
  else
    amPage.value = 'naviOff'
}

function onClickQR(){
  let params = {
    idx: viewIdx
  }
  BbsService.getBbs(params).then(
    (response) => {
      storeRef.popupIdx.value = viewIdx
      storeRef.popupTitle.value = response.result.monitoringTitle
      DialogQRModel.value = true
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}
</script>

<style lang="scss" scoped>
</style>
